<script>
import { forEach } from 'lodash'
import Vue from 'vue'
import marked from 'marked'

export default {
  props: {
    content: {
      type: [String, Boolean]
    },
    attributes: {
      type: Object
    },
    excerpt: {
      type: Boolean,
      default: false
    }
  },

  // Can we remove <excerpt> and attach it as an attribute?

  // http://stackoverflow.com/questions/40573011/dynamically-inject-vue-2-component-from-shortcode
  render (createElement) {
    if (!this.content) return
    const _this = this
    const component = Vue.component('markdown-vue-components', {
      template: `<div class="Markdown-content">${_this.body}</div>`
    })

    return createElement('div',
      { class: [ 'Markdown' ] }, [ createElement(component) ]
    )
  },

  computed: {
    body () {
      return this.parseMd(this.content)
    }
  },

  methods: {
    /**
     * Run text through markdown parser
     * - Match custom markdown tags to replace with custom components.
     */
    parseMd (text) {
      // Custom image tag:
      // - Format: ![Alt text](smugmug="smugmugKey" "Image title")
      text = text.replace(/!\[(.*)\]\(smugmug="([^"]*)"(?:.*"([^"]*)")?\)/g, (fullMatch, alt, smugmugId, title) => {
        return `<div class="Markdown-image"><image-component smugmug="${smugmugId}" alt="${alt || ''}" /></div>`
      })

      // Feature shortcode
      // TODO: share this with /app/pre-build/build-feeds.js
      if (this.attributes && this.attributes.features) {
        text = text.replace(/\[feature\s+ref="(.*)"\]/g, (fullMatch, ref) => {
          if (!this.attributes.features[ref - 1]) return ''
          let attrs = ''

          forEach(this.attributes.features[ref - 1], (value, key) => {
            value = JSON.stringify(value)
            value = value.replace(/"/g, '\'')

            attrs += ` :${key}="${value}"`
          })

          return `<feature${attrs} />`
        })
      }

      return marked(text)
    }
  }
}
</script>

<style>
@import 'properties';

.Markdown-content {

}

.Markdown-content > * + *,
.Markdown-content + .Markdown-content {
  margin-top: var(--unit);
}

.Markdown-content > * + .Grid {
  margin-top: var(--unit);
}

.Markdown-content .Grid + .GridCell,
.Markdown-content .GridCell + .GridCell {
  margin-top: 0;
}

.Markdown-content h3 {
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

.Markdown-content p + h3 {
  margin-top: var(--unit);
}

.Markdown-content p + p {
  margin-top: var(--unit-05);
}

.Markdown-content h3 + p {
  margin-top: 0;
}

.Markdown-content blockquote {
  margin-left: var(--unit);
  padding-left: var(--unit);
  border-left: 1px solid var(--c-grey-xxlt);
  color: var(--c-grey-lt);
}

.Markdown-content blockquote * + * {
  margin-top: var(--unit-05);
}

.Markdown-content blockquote cite {
  display: block;
}

.Markdown-content .ImageComponent + .ImageComponent {
  margin-top: var(--unit);
}

.Markdown * + .Feature {
  display: block;
  margin-top: var(--unit);
}

.Markdown-content ul {
  padding-left: var(--unit);
  list-style-type: disc;
}
</style>



// WEBPACK FOOTER //
// Markdown.vue?f232d7ee